goog.provide('el8.app.settings.staffDelegates');

goog.require('el8.app.settings.util');
goog.require('el8.template.app.settings.staffDelegates');
goog.require('el8.uiwidget.Form');
goog.require('el8.service.urls');

/**
 * A settings page for managing the delegates for one physician user.
 *
 * Note that "staff" here once meant literally OfficeStaff but now both Physicians and
 * OfficeStaff can be delegates for a Physician, so now it's analogous to "practice members."
 */
el8.app.settings.staffDelegates = (function() {

    var that = {};
    var $container;
    var form;

    // Keep these in the order they'll appear in the HTML, because this is also the order we'll
    // add them to the Form in. This list is probably all you need to change in this file to
    // support a new delegate type (you'll also have to update the staffDelegates template).

    var PERMISSION_TYPES =  ['rxs', 'orders', 'bills', 'referrals', 'messages'];

    var delegateStaffIdsMap = {};
    var delegateGroupIdsMap = {};

    that = {

        init: function(_container) {
            $container = _container;

            // create initial frame
            var $content = $(el8.template.app.settings.staffDelegates.content({}));
            $container.html($content).show();

            var getMrOpts = function(delegateType, anchorFromBottom) {
                return {
                    data: [], // will update below
                    containerWidth: 250,
                    anchorFromBottom: anchorFromBottom === true,
                    selectFn: function(event, item) {
                        mindreaderSelectFn(item, delegateType);
                    },
                    formatResult: function(item) { return item.fullName; },
                    formatSelected: function(item) { return item.fullName; },
                    rowToStringFn: function(item) { return item.fullName; },
                };
            };

            var fields = [];

            PERMISSION_TYPES.forEach(function(permissionType, idx) {
                var shouldAnchorFromBottom = idx === PERMISSION_TYPES.length - 1;
                var inputName = getFieldName(permissionType);
                var permissionTypeSingular = permissionType.slice(0, -1); // cut off the 's'

                fields.push({
                    name: inputName,
                    infoText: 'Add new '+permissionTypeSingular+' delegate...',
                    selector: ':input[name="'+inputName+'"]',
                    mindreaderOpts: getMrOpts(permissionType, shouldAnchorFromBottom),
                    newMindreader: true
                });
            });

            // TODO: This field is unnecessary once all practices have StaffGroupDelegates
            // feature flag enabled.
            if (!el8Globals.FEATURES.StaffGroupDelegates) {
                fields.push({
                    name: 'allowStaffToSendReferral',
                    selector: ':input[name="allowStaffToSendReferral"]'
                });
            }

            form = new el8.uiwidget.Form({
                container: $('form', $container),
                fields: fields
            });
            form.render();

            $.el8_ajax({
                url: el8.service.urls.get('staffDelegates', [el8.data.currUser.getStaffId()]),
                type: 'GET',
                success: function(data) {
                    for (var permissionType in data) {
                        if (data.hasOwnProperty(permissionType)) {
                            updateDelegateList(data[permissionType], permissionType);
                        }
                    }
                }
            });

            $.el8_ajax({
                url: el8.service.urls.get('staffGroupDelegates'),
                type: 'GET',
                success: function(data) {
                    for (var permissionType in data) {
                        if (data.hasOwnProperty(permissionType)) {
                            updateDelegateGroupList(data[permissionType], permissionType);
                        }
                    }
                }
            });

            // TODO: This field is unnecessary once all practices have StaffGroupDelegates
            // and the following blocks can be removed.
            if (!el8Globals.FEATURES.StaffGroupDelegates) {
                if (el8.data.currUser.isAllowStaffToSendReferrals()) {
                    form.setVal('allowStaffToSendReferral', 'on', true);
                } else {
                    form.setVal('allowStaffToSendReferral', 'off', true);
                }
            }

            bindTriggers($content);
        }

    };


    function bindTriggers($content) {
        $content.on('click', '.remove-delegate-trigger',  function() {
            var $this = $(this);
            var permissionType = $this.data('permission');
            $.el8_ajax({
                url: el8.service.urls.get('staffDelegates',
                        [el8.data.currUser.getStaffId(), $this.data('id'), permissionType]),
                type: 'DELETE',
                success: function(data) {
                    updateDelegateList(data, permissionType);
                }
            });
        })

        // TODO: Once all practices have the StaffGroupDelegates feature enabled
        // this change handler can be removed
        if (!el8Globals.FEATURES.StaffGroupDelegates) {
            $content.on('change', ':input[name="allowStaffToSendReferral"]',  function() {
                el8.data.currUser.setAllowStaffToSendReferrals(form.getVal('allowStaffToSendReferral') === 'on');
                var elt = $(this);

                el8.data.currUser.updatePreferences(function() {
                    el8.app.settings.util.handleSavedMsg(elt.closest('form').find('.confirm-msg'));
                });
            });
        }

    }

    function mindreaderSelectFn(mindreaderItem, permissionType) {
        var fieldName = getFieldName(permissionType);
        var practiceUser = el8.data.practiceUsers.getById(mindreaderItem.id);

        var _resetFieldFn = function() {
            form.clearField(fieldName);
            form.focusField(fieldName);
        };
        var _saveFn = function() {
            $.el8_ajax({
                url: el8.service.urls.get('staffDelegates',
                    [el8.data.currUser.getStaffId(), practiceUser.getStaffId(), permissionType]),
                type: 'POST',
                success: function(data) {
                    _resetFieldFn();
                    updateDelegateList(data, permissionType);
                }
            });
        };

        if (practiceUser.isPhysician() && _.contains(['rxs', 'orders'], permissionType)) {
            var confirmText, yesBtnText;
            if (permissionType === 'rxs') {
                confirmText = practiceUser.getFullName() + " has a provider account. Make them an RX delegate, " +
                    "who can only write prescriptions on behalf of another provider?";
                yesBtnText = 'Make Rx Delegate';
            } else if (permissionType === 'orders') {
                confirmText = practiceUser.getFullName() + " has a provider account. Make them an Order delegate, " +
                    "who can only write orders on behalf of another provider?";
                yesBtnText = 'Make Order Delegate';
            }
            el8.uiwidget.confirm(confirmText,
                _saveFn, // yesFn
                _resetFieldFn, // noFn
                { yesBtnText: yesBtnText, noBtnText: 'Cancel' }
            );
        } else {
            _saveFn();
        }
    }

    function updateDelegateGroupList(newList, permissionType) {
        delegateGroupIdsMap.permissionType = newList;
        $('.'+permissionType+'-delegated-group-list', $container).html(
            el8.template.app.settings.staffDelegates.delegatedStaffGroupList({
                delegatedStaffGroups: getDelegateGroupsAsMap(permissionType),
                permissionType: permissionType
            })
        ).removeClass('el8Loading');
    }

    // Store a new list, refresh the rendered list, and update the results in autocomplete
    function updateDelegateList(newList, permissionType) {
        delegateStaffIdsMap.permissionType = newList;
        $('.'+permissionType+'-delegated-list', $container).html(
            el8.template.app.settings.staffDelegates.delegatedStaffList({
                delegatedStaff: getDelegatesAsMap(permissionType),
                permissionType: permissionType
            })
        ).removeClass('el8Loading');
        updateDelegateAutocomplete(permissionType);
    }

    function updateDelegateAutocomplete(permissionType) {
        var existingDelegateUserIds = _.pluck(getDelegatesAsMap(permissionType), 'userId');
        var idsToExclude = existingDelegateUserIds.concat(el8.data.currUser.getId());
        var delegateAutocompletes = el8.data.practiceUsers.allExcept(idsToExclude).map(el8.model.toSoyMapFn);
        var fieldName = getFieldName(permissionType);
        var mindreader = form.getMindreader(fieldName);

        if (mindreader) {
            mindreader.updateSearchData(delegateAutocompletes);
        }
    }

    function getDelegatesAsMap(permissionType) {
        // The code that follows appears to be wrong but functional; the initial value
        // for `delegateStaffIdsMap` is an object with keys matching `permissionType`;
        // but when updating the map, we throw out the object in favor of setting `permissionType`
        // as an attribute on the map directly an array of whatever delegate type has
        // been most recently updated.
        //
        // This works because we are reading from and writing to the same location, and
        // the bug is hard to produce in the UI because of how fast the user interaction
        // would have to be.
        //
        // Following conversation on https://github.com/elationemr/hippo/pull/9137, we elected
        // not to change this code, because no one has actually reported an issue with
        // the current implementation.
        var staffIds = delegateStaffIdsMap.permissionType || [];
        var map = staffIds.map(function(staffId) {
            var practiceUser = el8.data.practiceUsers.getByStaffId(staffId);
            return {
                id: staffId,
                userId: practiceUser.getId(),
                name: practiceUser.getFullName()
            };
        });
        return map;
    }

    function getDelegateGroupsAsMap(permissionType) {
        // This implementation presents the same issue as the implementation of
        // getDelegatesAsMap that is commented on above, but for the sake of consistency
        // we have mirrored the implementation.
        var groupIds = delegateGroupIdsMap.permissionType || [];

        var map = groupIds.map(function(groupId) {
            var group = el8.data.staffGroups.getById(groupId);
            return {
                id: groupId,
                name: group.getName()
            };
        });

        return map;
    }

    function getFieldName(permissionType) {
        if (_.contains(PERMISSION_TYPES, permissionType)) {
            return 'newDelegate'+permissionType.capitalize();
        }
        UIM && UIM.logError('Invalid permissionType ' + permissionType + ' being referenced in delegate settings.');
        return null; // stuff should break if we didn't provide valid input
    }

    return that;


})();
